import { useState, useCallback, useMemo } from 'react';
import { adminApi } from '../../services/adminApi';
import AdminGrid from '../../components/admin/AdminGrid';

export default function CompanyProfiles() {
  const [dynamicYears, setDynamicYears] = useState([]);

  const columns = useMemo(() => {
    const baseCols = [
      { field: 'companyName', headerName: 'Company', minWidth: 180 },
      { field: 'legalName', headerName: 'Legal Name', minWidth: 160 },
      { field: 'country', headerName: 'Country' },
      { field: 'currency', headerName: 'Currency' },
      { field: 'fiscalYearStartMonth', headerName: 'FY Start Month' },
      { field: 'customers', headerName: 'Customers', filter: 'agNumberColumnFilter' },
      { field: 'vendors', headerName: 'Vendors', filter: 'agNumberColumnFilter' },
      { field: 'employees', headerName: 'Employees', filter: 'agNumberColumnFilter' },
      { field: 'classes', headerName: 'Classes', filter: 'agNumberColumnFilter' },
      { field: 'departments', headerName: 'Departments', filter: 'agNumberColumnFilter' },
      { field: 'terms', headerName: 'Terms', filter: 'agNumberColumnFilter' },
    ];

    const yearCols = dynamicYears.map(year => ({
      field: null,
      headerName: `FY ${year}`,
      valueGetter: (p) => p.data?.financialYears?.[year],
      colId: `fy_${year}`,
    }));

    return [...baseCols, ...yearCols];
  }, [dynamicYears]);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getCompanyProfiles({ page: 0, size: 10000 });
    const rows = res.content || [];
    if (rows.length > 0 && rows[0].financialYears) {
      setDynamicYears(Object.keys(rows[0].financialYears));
    }
    return rows;
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-100 mb-4">Company Profiles</h1>
      <AdminGrid columns={columns} fetchData={fetchData} />
    </div>
  );
}
